import * as actionTypes from './action-types';

export const skipToMainContent = () => ({
  type: actionTypes.SET_MAIN_CONTENT_FOCUSED,
  focused: true,
});

export const focusLeftMainContent = () => ({
  type: actionTypes.SET_MAIN_CONTENT_FOCUSED,
  focused: false,
});
